import { Project } from '@common/config'
import { lightTheme as portalTheme } from '@portal/UI/Theme'
import restTheme from '@rest/UI/Theme'

export default function useSafeTheme() {
  const { isRest } = Project
  return isRest ? restTheme : portalTheme
}
